import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowBack, Close } from '@material-ui/icons';

interface StickyPlayerControlsProps {
	onRestore: () => void;
	onClose: () => void;
}

const StickyPlayerControls: React.FC<StickyPlayerControlsProps> = ({ onRestore, onClose }) => {
	const { t } = useTranslation();

	return (
		<div className="qplayer-sticky-controls">
			<button
				type="button"
				className="qplayer-sticky-btn qplayer-sticky-restore"
				aria-label={t('MINI_PLAYER_RETURN_TO_PAGE')}
				title={t('MINI_PLAYER_RETURN_TO_PAGE')}
				onClick={(e) => {
					e.stopPropagation();
					onRestore();
				}}
			>
				<ArrowBack style={{ width: 16, height: 16, color: '#fff' }} />
			</button>
			<button
				type="button"
				className="qplayer-sticky-btn qplayer-sticky-close"
				aria-label={t('MINI_PLAYER_CLOSE')}
				title={t('MINI_PLAYER_CLOSE')}
				onClick={(e) => {
					e.stopPropagation();
					onClose();
				}}
			>
				<Close style={{ width: 16, height: 16, color: '#fff' }} />
			</button>
		</div>
	);
};

export default StickyPlayerControls;
